module.exports = {
  formData: {
    campaignTitle: '',
    advertiger: '',
    agency: '',
    mediaList: null,
    mediaListResult: [],

  },
  mediaInfo: {
    rootIndex : null,
    media_type : '',
    type : '',
    media: '',
    channel: '',
    vehicle: '',
    age: "769",
    minAge:7,
    maxAge:69,
    gender:'MF',
    genderLabel:'MF769',
    targetCode: 'MF769',
    demographic_cnt: 0,
    targetOnOff: true,
    budgetStr:0,
    budget:0,
    cpmStr: 0,
    cpm: 0,
    cpmUnit:'cpm',
    eImpStr: 0,
    eImp: 0,
    frequency: '미설정',
    formValidation:false,
    graphId:'1',
    grps: 0,
    reach1 : 0,
    minNumber : 1,
    maxNumber : 15,
    unit : 1000000,
  },
  ScreenMediaStructure : {
    "VA":{
      "TV": {
      },
      "PC": {
      },
      "Mobile": {
      },
      "Digital": {
      },
    },
    "DA":{
      "PC": {
      },
      "Mobile": {
      },
      "Digital": {
      },
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/common/ReachCurveFormData.js